<!-- eslint-disable -->
<template>
    <el-container class="container-fluid">
        <container-menu :collapse.sync="isCollapse"></container-menu>
        <el-container>
            <el-header class="flex items-center justify-between">
                <img class="container-header-logo" src="../../assets/images/title@1x.svg" alt="">
                <div class="flex justify-end items-center" style="width: 100%;">
                    <div class="relative">
                        <i class="el-icon-search absolute client-search-icon"></i>
                        <el-select
                            style="width: 262px;"
                            v-model="userId"
                            filterable
                            remote
                            reserve-keyword
                            :placeholder="$t('Member.search')"
                            :remote-method="fetchUser"
                            v-on:change="fetchUserInfo">
                            <el-option
                                v-for="item in users"
                                :key="item.id"
                                :label="item.resultText"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <el-tooltip
                        effect="dark"
                        :content="$t('tooltip.setting')"
                        placement="bottom">
                        <i
                            @click="setting"
                            class="container-icon-setting el-icon-setting">
                        </i>
                    </el-tooltip>
                    <el-tooltip
                        effect="dark"
                        :content="$t('tooltip.system')"
                        placement="bottom">
                        <i
                            @click="message('first')"
                            class="iconfont container-icon-system icon-fitness-xiaoxixinfengnews2">
                        </i>
                    </el-tooltip>
                    <el-tooltip
                        effect="dark"
                        :content="$t('tooltip.message')"
                        placement="bottom">
                        <el-badge v-if="count" :value="count" class="item">
                            <i
                                @click="message('second')"
                                class="iconfont container-icon-message icon-fitness-xiaoxi">
                            </i>
                        </el-badge>
                        <i
                            v-if="!count"
                            @click="message('second')"
                            class="iconfont container-icon-message icon-fitness-xiaoxi">
                        </i>
                    </el-tooltip>
                    <el-dropdown trigger="click" v-if="my">
                        <div class="click-area flex ">
                            <div class="flex flex-col justify-around">
                                <!-- <div>{{ my.account || 'admin' }}</div> -->
                                <div class="avatar" :style="`background-image: url(${avatar})`"></div>
                            </div>
                        </div>
                        <el-dropdown-menu class="header-admin-info" slot="dropdown">
                            <!-- <el-dropdown-item @click.native="$router.push('/my-profile')">个人信息</el-dropdown-item> -->
                            <el-dropdown-item @click.native="$router.push('/my-profile')">
                                <div class="flex justify-between items-center">
                                    <div class="flex items-center">
                                        <div class="avatar" :style="`background-image: url(${avatar})`"></div>
                                        <div>
                                            <div>{{ my.account }}</div>
                                            <div>{{ my.phone }}</div>
                                        </div>
                                    </div>
                                    <!-- 编辑 -->
                                    <div></div>
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="$router.push('/my-profile')">
                                <i class="iconfont icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy mr-4"></i>
                                {{ $t('Common.modify_password') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="this.my.isSuperAdmin"
                                @click.native="$router.push('/modify-phone')">
                                <i class="iconfont icon-fitness-shouji mr-4"></i>
                                {{ $t('Staff.Modify.administrator') }}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="logout">
                                <i class="mr-4 iconfont icon-fitness-tuichu"></i>
                                {{ $t('Common.logout') }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown trigger="click">
                        <div class="click-area flex ">
                            <div>{{ $t('System.title') }}</div>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="changeLangEvent('cn')">
                                {{ $t('System.cn') }}
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="changeLangEvent('en')">
                                {{ $t('System.en') }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </el-header>

            <el-main>
                <!--<breadcrumb></breadcrumb>-->
                <router-view></router-view>
            </el-main>

            <el-footer height="auto">Copyright © 2018 Ganguo</el-footer>
        </el-container>
    </el-container>
</template>

<script>
/* eslint-disable */
import {Container, Header, Main, Footer, Dropdown, DropdownMenu, DropdownItem, Badge} from 'element-ui';
import {mapState} from 'vuex';
import debounce from 'lodash/debounce';
// import Breadcrumb from './Breadcrumb';
import ContainerMenu from './ContainerMenu';
import handleUser from '@/mixins/handleUser.js';
import avatar from '@/assets/images/saas-no-avatar.png';

export default {
    components: {
        ElContainer: Container,
        ElHeader: Header,
        ElMain: Main,
        ElFooter: Footer,
        ElDropdown: Dropdown,
        ElDropdownMenu: DropdownMenu,
        ElDropdownItem: DropdownItem,
        ElBadge: Badge,
        // Breadcrumb,
        ContainerMenu,
    },
    props: [],
    mixins: [handleUser],
    data() {
        return {
            activeMenu: '',
            defaultOpeneds: [],
            isCollapse: true,
            avatar: null,
            users: [],
            userId: null,
            noAvatar: avatar,
            language: window.axios.defaults.headers.common['Accept-Language'],
        };
    },
    computed: {
        ...mapState([
            'my',
            'count',
        ]),
    },
    methods: {
        fetchMessageCount() {
            API.get('message/unread-count').then(res => {
                this.$store.commit('setCount', res.unreadCount);
            });
        },
        logout() {
            const loadingInstance = $ele.$loading();
            API.post('auth/logout').then((res) => {
                loadingInstance.close();
                sessionStorage.clear();
                window.location.reload();
            });
        },
        setting() {
            this.$router.push({
                name: 'Setting.List',
            });
        },
        message(val) {
            if (val === 'second' && !this.$$filterPermission('消息-消息列表-消息列表的查看')) {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
                return false;
            }
            this.$router.push({
                name: 'Message.List',
                query: {
                    activeName: val,
                },
            });
        },
        fetchUser(val = '') {
            API.get('client/search', {
                params: {
                    keyword: val,
                },
            }).then(res => {
                this.users = res;
            });
        },
        fetchUserInfo() {
            if (!this.$$filterPermission('搜索-全部搜索-可搜索全部') && !this.$$filterPermission('搜索-全部搜索-仅搜索分配给我的')) return;
            this.handleUser(this.userId);
            setTimeout(() => {
                this.userId = null;
                this.users = [];
            });
        },
        changeLangEvent(val) {
            $ele.$confirm(this.$t('System.sure'), this.$t('Common.tip'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                this.$i18n.locale = val;
                window.axios.defaults.headers.common['Accept-Language'] = val === 'cn' ? 'zh' : val;
                sessionStorage.setItem('language', val);
                setTimeout(() => {window.location.href = '';}, 300);
            }).catch(() => {
            });
        },
    },
    created() {
        this.activeMenu = this.$route.name;
        this.avatar = this.my.avatar || this.noAvatar;
        this.fetchMessageCount();
    },
};
</script>

<style lang="scss">
    .container-fluid {
        height: 100vh;
        color: rgba(0, 0, 0, 0.65);

        > .el-container {
            > .el-header {
                width: 100%;
                height: 60px;
                color: rgba(0, 0, 0, 0.65);
                background: #fff;
                box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
                position: sticky;
                top: 0;
                z-index: 1;

                .hamburger{
                    margin-left: -20px;
                }

                .click-area {
                    cursor: pointer;
                    margin-left: 15px;
                }
                .avatar {
                    display: inline-block;
                    width: 35px;
                    height: 35px;
                    padding: 2px;
                    border-radius: 50%;
                    cursor: pointer;
                    overflow: hidden;
                    vertical-align: middle;
                    background-size: cover;
                    background-position: center;
                }
            }

            > .el-main, > .el-footer{
                background: #f0f2f5;
            }
        }
    }
    .client-search-icon {
        z-index: 2;
        font-size: 13px;
        top: 50%;
        transform: translateY(-50%);
        right: 6px;
        color: #ccc;
    }
    .container-icon-setting {
        font-size: 22px;
        display: inline-block;
        margin: 0 0 0 10px;
    }
    .container-icon-system {
        font-size: 23px;
        display: inline-block;
        margin: 0 15px;
    }
    .container-icon-message {
        font-size: 25px;
        display: inline-block;
    }
    .header-admin-info {
        width: 260px;
        padding: 0 !important;
        .el-dropdown-menu__item {
            border-bottom: 1px solid #f6f6f6;
            padding: 10px 20px !important;
            &:last-child {
                border-bottom: none;
            }
        }
        .avatar {
            display: inline-block;
            width: 35px;
            height: 35px;
            padding: 2px;
            margin-right: 10px;
            border-radius: 50%;
            cursor: pointer;
            overflow: hidden;
            vertical-align: middle;
            background-size: cover;
            background-position: center;
        }
    }
    .el-badge__content {
        right: 14px !important;
    }
    .container-header-logo {
        height: 28px;
    }
</style>
